import styled, { keyframes } from 'styled-components';

export const ModalOrdemServico = styled.div`
  text-align: center;
  height: auto;
  display: flex;
  background: #ffffffff;
  border-radius: 12px;
  width: 100%;
`;

export const ContainerTableServiço = styled.div`
    width: 100%;
    padding: 20px;
    height: auto;
`;

export const ContainerTableOs = styled.div`
  width: 100%;
  margin: 0 auto;


    /* Custom scrollbar X styles */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 12px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d4d4d4;
    border-radius: 12px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #b0b0b0;
  }
`;

export const Teste = styled.div`
overflow-y: auto;
overflow-x: hidden;
height: 400px;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const BtnExportExcel = styled.div`
  border-radius: 4px;
  border-style: none;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  background-color: #005a9e;
  padding: 8px;
  display: flex;
  font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-size: 14px;
  font-weight: 500;
  height: 35px;
  line-height: 20px;
  list-style: none;
  transition: color 100ms;
  margin-right: 10px;
  justify-content: center;
  align-items: center;
  text-align: center;

  &:hover {
    color: #4096ff;
    border: 1px solid #4096ff;
    background: #ffffff;
    transition: 0.2s;
  }
`;

export const ItemTable = styled.div`
  width: 100%;
  height: auto;
  border-radius: 8px;
  border-left: 3px solid #e3e3e3;
  background: #fff;
  box-shadow: rgb(0 0 0 / 2%) 0px 3px 3px 0px;

  &:hover {
      background-color: #f6f6f6;
    }

  ul {
    display: flex;
    padding: 8px;

    li {
      margin: 10px;
      list-style-type: none;
      font-size: 12px;
      color: #737373;
      width:100%;
    }
  }

  .icon-logout {
    color: #fff;
    display: flex;
  }
`;

export const ContainerControllers = styled.div`
  display: flex;
  width: 100%;

  .containerRegistr{
      background: white;
    border-radius: 4px;
    position: relative;
    left: 30px;
    border-left: 3px solid #ffe456;
    margin-bottom: 5px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    color: #707070;
  }

  .titleRegistr {
    width: 300px;
    padding: 5px;
  }

  .totalRegistr {
    display: flex;
    width: 100%;
    text-align: left;
    margin: auto;
    padding: 5px 30px;
    border-radius: 8px;

    .iconRegistr {
      width: 50px;
      text-align: center;
      font-size: 22px;
    }

    .numberRegistr {
      font-size: 22px;
      width: auto;
      text-align: center;
      color:#5b5b5b;
    }

    .span {
      padding: 10px 100px;
      border-radius: 8px;
      font-size: 22px;
      color: #605d5d;
      background: #ffffff;
      box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
    }
  }
`;

export const ItemInput = styled.div`
width:100%;
`;

export const ItemBtnExport = styled.div`
  width: 100%;
  justify-content: right;
  display: flex;

  .info-data-excel {
    display: flex;
  }

  .result {
    text-align: right;
    margin-right: 10px;
  }

  .result-icon {
    text-align: right;
    margin-right: 10px;
    font-size: 20px;
    color: #7e7e7e;
  }

  .result-title {
    color: #7e7e7e;
    font-size: 14px;
  }
  .result-value {
    color: #0361a7;
    font-weight: 700;
  }

    .icon{
    position: relative;
    top: 3px;
    }
`;




